import React from 'react';
import { withAuthDomain } from '../../components/Session';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import {Grid, Paper, Typography } from '@material-ui/core';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import StarIcon from '@material-ui/icons/StarBorder';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Divider from '@material-ui/core/Divider';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';
import Chip from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import DoneIcon from '@material-ui/icons/Done';
const useStyles = makeStyles(theme => ({
  root: {
    overscrollBehavior: "contain",
    maxWidth:"100vw",
    minHeight:"89vh",
    overflow:"auto",
    margin:"0px",
    padding:"0px",
    paddingBottom:"70px",
    position:"relative",
    userSelect:"none", 
  },
  paper:{
    margin:"10px",
    padding:"20px",
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
}));

const DomainSettingsPage = (props) => {
  const {
    firebase,
    currentUser,
    companyView,
    branchView,
    employeeData,
    sessionDomain,
    domainExpirationStatus,
    featureStatus,
    errorPosition,
    
    width,
    currentDate,
    serverMillis,
    serverClockStatus,
    activeCompany,
    
    //...otherProps
  }=props
  const classes = useStyles();
  
  const [publicDomainList,setPublicDomainList]=React.useState([])
  //const [customDomainList,setCustomDomainList]=React.useState([])
  const [subscriptionDomainList,setSubscriptionDomainList]=React.useState([])
  const [ownCustomDomainList,setOwnCustomDomainList]=React.useState([])
  
  
  //const [newCompanyType,setNewCompanyType]=React.useState("")
  
  /*React.useEffect(()=>{
    setPublicDomainList([])
    //setCustomDomainList([])
    setOwnCustomDomainList([])
    if(!!activeCompany){
      return firebase.fs.collection("domains").onSnapshot((querySnapshot) => {
        var pubDomain=[]
        var cusDomain=[]
        querySnapshot.forEach(function(doc) {
          var obj=doc.data()
          if(obj.isPrivateDomain){
            cusDomain.push(obj)
          }else{
            pubDomain.push(obj)
          }
        });
        setPublicDomainList(pubDomain)
        console.log("setPublicDomainList",pubDomain)
        //setCustomDomainList(cusDomain)
        var newOrder=[]
        for(var i=0;i<cusDomain.length;i++){
          if(cusDomain[i].domainOwner===activeCompany.id){
            newOrder.push(cusDomain[i])
          }
        }
        setOwnCustomDomainList(newOrder)
        console.log("setOwnCustomDomainList",newOrder)

      },(e)=>{
        console.log("error get domains : "+e)
      })
    }
  },[activeCompany])*/

  React.useEffect(()=>{
    setOwnCustomDomainList([])
    if(!!activeCompany){
      return firebase.fs.collection("domains")
      .where("domainOwner","==",activeCompany.id)
      .where("isPrivateDomain","==",true)
      .where("type","==",activeCompany.type)
      .onSnapshot((querySnapshot) => {
        var newOrder=[]
        querySnapshot.forEach(function(doc) {
          var obj=doc.data()
          newOrder.push(obj)
        });
        //console.log("setOwnCustomDomainList",newOrder)
        setOwnCustomDomainList(newOrder)
      },(e)=>{
        console.log("error get own domains : "+e)
      })
    }
  },[activeCompany])

  React.useEffect(()=>{
    setPublicDomainList([])
    if(!!activeCompany){
      return firebase.fs.collection("domains")
      .where("domainOwner","==","Public")
      .where("isPrivateDomain","==",false)
      .where("type","==",activeCompany.type)
      .onSnapshot((querySnapshot) => {
        var pubDomain=[]
        querySnapshot.forEach(function(doc) {
          var obj=doc.data()
          pubDomain.push(obj)
        });
        //console.log("setPublicDomainList",pubDomain)
        setPublicDomainList(pubDomain)
      },(e)=>{
        console.log("error get public domains : "+e)
      })
    }
  },[activeCompany])


  /*React.useEffect(()=>{
    var newOrder=[]
    for(var i=0;i<customDomainList.length;i++){
      if(customDomainList[i].domainOwner===activeCompany.id){
        newOrder.push(customDomainList[i])
      }
    }
    setOwnCustomDomainList(newOrder)
  },[activeCompany,customDomainList])*/

  React.useEffect(()=>{
    if(!!activeCompany){
      return firebase.fs.collectionGroup('domainSubscribers').where('companyId', '==', activeCompany.id).onSnapshot((querySnapshot) => {
        var subsDomain=[]
        querySnapshot.forEach(function(doc) {
          var obj=doc.data()
          subsDomain.push(obj)
        });
        setSubscriptionDomainList(subsDomain)
        //console.log("setSubscriptionDomainList",subsDomain)
      },(e)=>{
        console.log("error get domains : "+e)
      })
    }
  },[activeCompany])

  const [companyBranches,setCompanyBranches]=React.useState([])
  React.useEffect(()=>{
    setCompanyBranches([])
    if(!activeCompany||(!!activeCompany&&!activeCompany.id)){
      return
    }
    return firebase.fs.collection("companies/"+activeCompany.id+"/branches").onSnapshot((querySnapshot) => {
      var arr=[]
      querySnapshot.forEach(function(doc) {
        var obj=doc.data()
        arr.push(obj)
      });
      setCompanyBranches(arr)
    },(e)=>{
      console.log("error get branches : "+e)
    })
  },[firebase,activeCompany])

  
  function toURL(name){
    var arr=name.toLowerCase().split(" ")
    return "https://"+arr.join(".")+".web.app"
  }

  function requestCustomDomain(domain){
    var yes = window.confirm("Custom domain hanya untuk pelanggan PRO.\nApakah Anda ingin mengajukan Custom Domain Anda?")
    if(yes){
      var requestCustomDomain=window.prompt("Tulis Custom Domain yang ingin Anda buat !",domain)
      if(!requestCustomDomain)return
      var url = 'https://api.whatsapp.com/send?phone=' 
     + '6285736596779' 
     + '&text=' 
     + encodeURIComponent("Pengajuan custom domain "+requestCustomDomain)
     window.open(url)
    }
  }

  /*function checkSubscriptionCustomDomain(domain){
    for(var i=0;i<ownCustomDomainList.length;i++){
      if(ownCustomDomainList[i].domainName===domain.name&&ownCustomDomainList[i].enabled){
        return true
      }
    }
    return false
  }*/
 
  function checkSubscriptionDomain(domain){
    for(var i=0;i<subscriptionDomainList.length;i++){
      if(subscriptionDomainList[i].domainName===domain.name&&subscriptionDomainList[i].enabled){
        return true
      }
    }
    return false
  }

  async function toggleSubscribePublicDomain(domain){
    if(checkSubscriptionDomain(domain)){
      //unsubscribe
      var batch = firebase.fs.batch()
      batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+activeCompany.id),{
        enabled:false,
      },{merge:true})

      try{
        var branches = await firebase.fs.collection("companies/"+activeCompany.id+"/branches").get()
        for(var i=0;i<branches.docs.length;i++){
          var obj=branches.docs[i].data()
          batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+activeCompany.id+"/branchSubscribers/"+branches.docs[i].id),{
            enabled:false,
          },{merge:true})
        }
      }catch(e){

      }

      batch.commit()
      .then()
      .catch(e=>{
        alert("Gagal unsubscribe : "+e)
      })

    }else{
      //subscribe
      var expiration=0
      try{
        var companySubsDoc= await firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+activeCompany.id).get()
        if(companySubsDoc.exists){
          expiration=companySubsDoc.data().expiration
        }
      }catch(e){
      }
      
      var batch = firebase.fs.batch()
      batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+activeCompany.id),{
        ...activeCompany,
        companyId:activeCompany.id,
        domainName:domain.name,
        enabled:true,
        expiration:expiration===0?(serverMillis+(1000*60*60*24*45)):expiration,
        //name:activeCompany.name,
      },{merge:true})

      try{
        var branches = await firebase.fs.collection("companies/"+activeCompany.id+"/branches").get()
        for(var i=0;i<branches.docs.length;i++){
          var obj=branches.docs[i].data()
          batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+activeCompany.id+"/branchSubscribers/"+branches.docs[i].id),{
            ...obj,
            enabled:true,
            features:getDefaultDomainFeatures(activeCompany.type),
            lat:obj.lat||0,
            lng:obj.lng||0,
            //name:obj.name||"",
          },{merge:true})
        }
      }catch(e){
      }

      batch.commit()
      .then()
      .catch(e=>{
        alert("Gagal subscribe : "+e)
      })
    }
  }

  function toggleEnableCustomDomain(domain){
    firebase.fs.doc("domains/"+domain.name).set(
      {
        enabled:!domain.enabled,
      },{merge:true}
    ).then(()=>{
      //toggleSubscribePublicDomain(domain)
    })
    .catch(e=>{
      alert("Gagal : "+e)
    })
  }

  return (
    <div className={classes.root}>
      {sessionDomain>=1&&!!activeCompany&&
        <Grid container direction={width==="xs"?"column":"row"} justify={width==="xs"?"center":"flex-start"} alignItems={width==="xs"?"stretch":"flex-start"}>
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Publik Domain{width==="xs"?<br/>:null}
              </Typography>
              <List>
                {publicDomainList.map((domain,idx)=>domain.type!==activeCompany.type?null:
                  <ListItemDomain
                    key={domain.name+idx}
                    domain={domain}
                    firebase={firebase}
                    companyId={activeCompany.id}
                    companyBranches={companyBranches}
                    companyType={activeCompany.type}
                    idx={idx}
                    width={width}
                    isSubscripting={checkSubscriptionDomain(domain)}
                    onCheckboxCheckedChange={()=>toggleSubscribePublicDomain(domain)}
                  />
                )}
              </List>
            </Paper>
          </Grid>
          
          <Grid item xs={12} style={{margin:width==="xs"?"10px":"0px"}}>
            <Paper elevation={3} className={classes.paper} style={{minHeight:"100px",width:width==="xs"?"95%":"98%%"}}>
              <Typography variant="h5">
                Custom Domain{width==="xs"?<br/>:null}
                {ownCustomDomainList.length>0&&<Button style={{float:"right"}} variant="contained" color="primary" onClick={()=>requestCustomDomain("")}>Tambah</Button>}
              </Typography>
                {ownCustomDomainList.length===0&&
                  <Button variant="contained" color="secondary" style={{marginTop:"10px"}} onClick={()=>requestCustomDomain(toURL(activeCompany.name))}>Ajukan web {toURL(activeCompany.name)}</Button>
                }
              <List>
                
                {ownCustomDomainList.map((dom,idx)=>dom.type!==activeCompany.type?null:
                  <ListItemDomain
                    key={dom.name+idx}
                    domain={dom}
                    firebase={firebase}
                    companyId={activeCompany.id}
                    companyBranches={companyBranches}
                    companyType={activeCompany.type}
                    idx={idx}
                    width={width}
                    isCustomDomain={true}
                    isSubscripting={checkSubscriptionDomain(dom)}
                    onCheckboxCheckedChange={()=>toggleSubscribePublicDomain(dom)}
                    /*onSubscripting={(dom)=>{
                      firebase.fs.doc("domains/"+dom.name).set(
                        {
                          enabled:true,
                        },{merge:true}
                      ).then(()=>{
                      })
                      .catch(e=>{
                        alert("Gagal : "+e)
                      })
                    }}
                    onUnsubscripting={dom=>{
                      firebase.fs.doc("domains/"+dom.name).set(
                        {
                          enabled:false,
                        },{merge:true}
                      ).then(()=>{
                      })
                      .catch(e=>{
                        alert("Gagal : "+e)
                      })
                    }}*/
                  />
                )}
              </List>
            </Paper>
          </Grid>
        </Grid>
      }
    </div>
  )
}

/*

<ListItem key={domain.URL||idx} dense={width!=="xs"}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={domain.enabled}
                        onClick={()=>toggleEnableCustomDomain(domain)}
                      />
                      </ListItemIcon>
                    <ListItemText primary={domain.URL} secondary={domain.description}/>
                    <ListItemSecondaryAction>
                      
                      <IconButton edge="end" aria-label="go" onClick={()=>{window.open(domain.URL)}}>
                        <OpenInNewIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>

*/
/*
function ListItemCustomDomain(props){
  const {
    domain={},
    idx=-1,
    width="xs",
    companyId,
    firebase,
    companyBranches=[],
    companyType="",
    isSubscripting=()=>{},//checkSubscriptionDomain(domain)
    onCheckboxCheckedChange=()=>{},//()=>toggleSubscribePublicDomain(domain)
    //onSubscripting,
    //onUnsubscripting,

  }=props


  const [branchSubscribers,setBranchSubscribers]=React.useState([])
  const [combinedBranchSubscribers,setCombinedBranchSubscribers]=React.useState([])

  React.useEffect(()=>{
    setBranchSubscribers([])
    if(!domain||!companyId){
      return
    }
    return firebase.fs.collection("domains/"+domain.name+"/domainSubscribers/"+companyId+"/branchSubscribers").onSnapshot((querySnapshot) => {
      var arr=[]
      querySnapshot.forEach(function(doc) {
        var obj=doc.data()
        var id=doc.id
        obj.id=id
        arr.push(obj)
      });
      setBranchSubscribers(arr)
      console.log("branchSubscribers "+domain.name,arr)
    },(e)=>{
      console.log("error get branchSubscribers : "+e)
    })
  },[firebase,domain,companyId])

  

  React.useEffect(()=>{
    var result=[...companyBranches]
    for(var i=0;i<result.length;i++){
      for(var j=0;j<branchSubscribers.length;j++){
        if(result[i].id===branchSubscribers[j].id){
          result[i].isSubscripting=branchSubscribers[j].enabled
          break
        }
      }
    }
    //result.sort(function(a, b){return a.createdDate - b.createdDate});
    setCombinedBranchSubscribers(result)
    console.log("setCombinedBranchSubscribers "+domain.name,result)
  },[companyBranches,branchSubscribers])

  async function doUnsubscribe(branch){
    /*if(!!onUnsubscripting){
      onUnsubscripting(domain,branch)
      return
    }*
    if(!domain||!branch||!companyId)return
    var batch = firebase.fs.batch()
    batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+companyId+"/branchSubscribers/"+branch.id),{
      enabled:false,
    },{merge:true})
    batch.commit()
    .then()
    .catch(e=>{
      alert("Gagal unsubscribe : "+e)
    })
  }
  async function doSubscribe(branch){
    /*if(!!onSubscripting){
      onSubscripting(domain,branch)
      return
    }*
    if(!domain||!branch||!companyId)return

    var batch = firebase.fs.batch()
    batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+companyId+"/branchSubscribers/"+branch.id),{
      enabled:true,
      features:getDefaultDomainFeatures(companyType),
      lat:branch.lat||0,
      lng:branch.lng||0,
      name:branch.name||"",
    },{merge:true})
    batch.commit()
    .then()
    .catch(e=>{
      alert("Gagal subscribe : "+e)
    })
  }
  return (
    <>
    <ListItem dense={width!=="xs"}>
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={isSubscripting}
          onClick={onCheckboxCheckedChange}
        />
      </ListItemIcon>
      <ListItemText 
        primary={domain.URL} 
        secondary={ domain.description}
      />
      <ListItemSecondaryAction>
        {isSubscripting?
          <IconButton edge="end" aria-label="go" onClick={()=>{window.open(domain.URL)}}>
            <OpenInNewIcon />
          </IconButton>
        :
          null
        }
      </ListItemSecondaryAction>
    </ListItem>
    <div style={{padding:"5px 64px", display:isSubscripting?"block":"none"}}>
    {combinedBranchSubscribers.map((obj,idx)=>{
      return (
        <Chip
          key={obj.name+idx} 
          style={{margin:"10px"}} 
          color={obj.isSubscripting?"secondary":"primary"} 
          variant={obj.isSubscripting?"default":"outlined"} 
          label={obj.name} 
          deleteIcon={obj.isSubscripting?<DoneIcon />:null} 
          onDelete={obj.isSubscripting?()=>doUnsubscribe(obj):null}
          onClick={()=>obj.isSubscripting?doUnsubscribe(obj):doSubscribe(obj)}
        />
      )
    })}
    </div>
    <Divider/>
    </>
  )
}*/


function ListItemDomain(props){
  const {
    domain={},
    idx=-1,
    width="xs",
    companyId,
    firebase,
    companyBranches=[],
    companyType="",
    isCustomDomain=false,
    isSubscripting=()=>{},//checkSubscriptionDomain(domain)
    onCheckboxCheckedChange=()=>{},//()=>toggleSubscribePublicDomain(domain)
    onSubscripting,
    onUnsubscripting,

  }=props


  const [branchSubscribers,setBranchSubscribers]=React.useState([])
  const [combinedBranchSubscribers,setCombinedBranchSubscribers]=React.useState([])

  React.useEffect(()=>{
    setBranchSubscribers([])
    if(!domain||!companyId){
      return
    }
    return firebase.fs.collection("domains/"+domain.name+"/domainSubscribers/"+companyId+"/branchSubscribers").onSnapshot((querySnapshot) => {
      var arr=[]
      querySnapshot.forEach(function(doc) {
        var obj=doc.data()
        var id=doc.id
        obj.id=id
        arr.push(obj)
      });
      //console.log("branchSubscribers "+domain.name,arr)
      setBranchSubscribers(arr)
    },(e)=>{
      console.log("error get branchSubscribers : "+e)
    })
  },[firebase,domain,companyId])

  

  React.useEffect(()=>{
    var result=[]
    for(var z=0;z<companyBranches.length;z++){
      result.push({
        ...companyBranches[z],
        isSubscripting:false,
        key:domain.name+companyBranches[z].id
      })
    }
    
    
    for(var i=0;i<result.length;i++){
      for(var j=0;j<branchSubscribers.length;j++){
        if(result[i].id===branchSubscribers[j].id){
          //console.log(domain.name+result[i].id,"isSubscripting="+(branchSubscribers[j].enabled))
          result[i].isSubscripting=branchSubscribers[j].enabled
          result[i].key=domain.name+result[i].id
          break
        }
      }
    }


    //result.sort(function(a, b){return a.createdDate - b.createdDate});
    //console.log("setCombinedBranchSubscribers "+domain.name,result)
    setCombinedBranchSubscribers(result)
  },[companyBranches,branchSubscribers])

  async function doUnsubscribe(branch){
    if(!!onUnsubscripting){
      onUnsubscripting(domain,branch)
      return
    }
    if(!domain||!branch||!companyId)return
    var batch = firebase.fs.batch()
    batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+companyId+"/branchSubscribers/"+branch.id),{
      enabled:false,
    },{merge:true})
    batch.commit()
    .then()
    .catch(e=>{
      alert("Gagal unsubscribe : "+e)
    })
  }
  async function doSubscribe(branch){
    if(!!onSubscripting){
      onSubscripting(domain,branch)
      return
    }
    if(!domain||!branch||!companyId)return

    var batch = firebase.fs.batch()
    batch.set(firebase.fs.doc("domains/"+domain.name+"/domainSubscribers/"+companyId+"/branchSubscribers/"+branch.id),{
      ...branch,
      enabled:true,
      features:getDefaultDomainFeatures(companyType),
      lat:branch.lat||0,
      lng:branch.lng||0,
      //name:branch.name||"",
    },{merge:true})
    batch.commit()
    .then()
    .catch(e=>{
      alert("Gagal subscribe : "+e)
    })
  }
  return (
    <>
    <ListItem dense={width!=="xs"}>
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={isSubscripting}
          onClick={onCheckboxCheckedChange}
        />
      </ListItemIcon>
      <ListItemText 
        primary={domain.URL} 
        secondary={ domain.description}
      />
      <ListItemSecondaryAction>
        {isSubscripting?
          <IconButton edge="end" aria-label="go" onClick={()=>{window.open(domain.URL)}}>
            <OpenInNewIcon />
          </IconButton>
        :isCustomDomain?
          null
        :
          <span style={{fontWeight:"bold",fontSize:"16px"}}>FREE</span>
        }
      </ListItemSecondaryAction>
    </ListItem>
    <div style={{padding:"5px 64px", display:isSubscripting?"block":"none"}}>
    {combinedBranchSubscribers.map((obj,idx)=>{
      return (
        <Chip
          key={obj.key+idx} 
          style={{margin:"10px"}} 
          color={obj.isSubscripting?"secondary":"primary"} 
          variant={obj.isSubscripting?"default":"outlined"} 
          label={obj.name} 
          deleteIcon={obj.isSubscripting?<DoneIcon />:null} 
          onDelete={obj.isSubscripting?()=>doUnsubscribe(obj):null}
          onClick={()=>obj.isSubscripting?doUnsubscribe(obj):doSubscribe(obj)}
        />
      )
    })}
    </div>
    <Divider/>
    </>
  )
}


function getDefaultDomainFeatures(type){
  switch(type){
    case "Finance":
      return [
        //"barokah-usaha-finance.penjualan",
        //"barokah-usaha-finance.returPenjualan",
        //"barokah-usaha-finance.pembelian",
        //"barokah-usaha-finance.returPembelian",
        "barokah-usaha-finance.pemasukan",
        "barokah-usaha-finance.pengeluaran",
        //"barokah-usaha-finance.produksi",
        //"barokah-usaha-finance.dataProduk",
        //"barokah-usaha-finance.dataStok",
        "barokah-usaha-finance.hutang",
        "barokah-usaha-finance.piutang",
        "barokah-usaha-finance.aset",
        "barokah-usaha-finance.operator",
        //"barokah-usaha-finance.customer",
        //"barokah-usaha-finance.supplier",
        //"barokah-usaha-finance.reseller",
        
        //"barokah-usaha-finance.dataAntrian",
        //"barokah-usaha-finance.dataPenawaran",
        //"barokah-usaha-finance.dataPO",
  
        //"barokah-usaha-finance.laporanJurnal",
        //"barokah-usaha-finance.laporanLabaRugi",
        //"barokah-usaha-finance.laporanNeracaSaldo",
        //"barokah-usaha-finance.laporanNeraca",
        "barokah-usaha-finance.laporanArusKas",
        //"barokah-usaha-finance.laporanPemasaran",

        "barokah-usaha-finance.settings",
        
        "branch.settings",
        "branch.employee",
        "barokah-usaha-finance.administrator",
      ]
      break
    case "Market":
      return [
        "barokah-usaha-market.penjualan",
        "barokah-usaha-market.returPenjualan",
        "barokah-usaha-market.pembelian",
        "barokah-usaha-market.returPembelian",
        "barokah-usaha-market.pemasukan",
        "barokah-usaha-market.pengeluaran",
        //"barokah-usaha-market.produksi",
        "barokah-usaha-market.dataProduk",
        "barokah-usaha-market.dataStok",
        "barokah-usaha-market.hutang",
        "barokah-usaha-market.piutang",
        "barokah-usaha-market.aset",
        "barokah-usaha-market.operator",
        "barokah-usaha-market.customer",
        "barokah-usaha-market.supplier",
        "barokah-usaha-market.reseller",
        
        "barokah-usaha-market.dataAntrian",
        "barokah-usaha-market.dataPenawaran",
        "barokah-usaha-market.dataPO",
  
        "barokah-usaha-market.laporanJurnal",
        "barokah-usaha-market.laporanLabaRugi",
        "barokah-usaha-market.laporanNeracaSaldo",
        "barokah-usaha-market.laporanNeraca",
        "barokah-usaha-market.laporanArusKas",
        "barokah-usaha-market.laporanPemasaran",

        "barokah-usaha-market.settings",
        
        "branch.settings",
        "branch.employee",
        "barokah-usaha-market.administrator",
      ]
      break
    case "Workshop":
      return [
        "barokah-usaha-bengkel.service",
        "barokah-usaha-bengkel.sparepart",
        "barokah-usaha-bengkel.finance",
        "barokah-usaha-bengkel.dataContacts",
        "barokah-usaha-bengkel.dataVehicles",
        "barokah-usaha-bengkel.dataProducts",
        "barokah-usaha-bengkel.transactionReport",
        "barokah-usaha-bengkel.financeReport",
        "barokah-usaha-bengkel.stockReport",
        "barokah-usaha-bengkel.vehicleReport",
        "barokah-usaha-bengkel.employee",
        "barokah-usaha-bengkel.billing",

        "barokah-usaha-bengkel.settings",
      ]
      break
    case "Production":
      return [
        "barokah-usaha-produksi.penjualan",
        "barokah-usaha-produksi.returPenjualan",
        "barokah-usaha-produksi.pembelian",
        "barokah-usaha-produksi.returPembelian",
        "barokah-usaha-produksi.pemasukan",
        "barokah-usaha-produksi.pengeluaran",
        "barokah-usaha-produksi.produksi",
        "barokah-usaha-produksi.dataProduk",
        "barokah-usaha-produksi.dataStok",
        "barokah-usaha-produksi.hutang",
        "barokah-usaha-produksi.piutang",
        "barokah-usaha-produksi.aset",
        "barokah-usaha-produksi.operator",
        "barokah-usaha-produksi.customer",
        "barokah-usaha-produksi.supplier",
        "barokah-usaha-produksi.reseller",
        
        "barokah-usaha-produksi.dataAntrian",
        "barokah-usaha-produksi.dataPenawaran",
        "barokah-usaha-produksi.dataPO",
  
        "barokah-usaha-produksi.laporanJurnal",
        "barokah-usaha-produksi.laporanLabaRugi",
        "barokah-usaha-produksi.laporanNeracaSaldo",
        "barokah-usaha-produksi.laporanNeraca",
        "barokah-usaha-produksi.laporanArusKas",
        "barokah-usaha-produksi.laporanPemasaran",

        "barokah-usaha-produksi.settings",
        
        "branch.settings",
        "branch.employee",
        "barokah-usaha-produksi.administrator",
      ]
      break
    case "Restaurant":
      return [
        "barokah-usaha-restaurant.settings",
        
        "branch.settings",
        "branch.employee",
        "barokah-usaha-restaurant.administrator",
      ]
      break
  }
  return []
}

const condition = authUser => !!authUser;
export default withAuthDomain(condition,false,"online-asset-manager","")(withWidth()(DomainSettingsPage));